// import { getBaseUrl } from "@iso/lib/helpers/utility";
import io from 'socket.io-client';

let desktopRoom = 'clientDesktopP7';
let desktopSocket;
let desktopSocketURL = 'http://localhost:8765';

class DesktopWSControll {

    async start(callback) {
        desktopSocket = io(`${desktopSocketURL}`)

        desktopSocket.on("connect", () => {
            console.log('Connect:', desktopSocket.connected);
            desktopSocket.emit("join_room", { room: desktopRoom });

            // setTimeout(() => {
            //     desktopSocket.emit("message", { message: 'Teste laaaaaa' });
            // }, 5000);
        });

        desktopSocket.on("disconnect", () => {
            console.log('Disconnect:', desktopSocket.connected);
        });

        desktopSocket.on("connect_error", (error) => {
            console.log('connect_error:', desktopSocket.connected);
        });

        desktopSocket.on('message', async (data) => {
            callback('message', data);
        });
    }

    async send(attr, data) {
        desktopSocket.emit(attr, data);
    }

    async finish() {
        desktopSocket.off('sendMessage', null);
        desktopSocket.disconnect()
        desktopSocket.close()
    }
}

export default new DesktopWSControll();